import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Modal from "@cloudscape-design/components/modal";
import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Box from "@cloudscape-design/components/box";
import Alert from "@cloudscape-design/components/alert";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { staffLogModalStore } from "../stores/staffLogModal";
import Tabs from "@cloudscape-design/components/tabs";
import Select from "@cloudscape-design/components/select";
import Button from "@cloudscape-design/components/button";
import Container from "@cloudscape-design/components/container";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Grid from "@cloudscape-design/components/grid";
import { staffDetailLog, staffDetailLogStore } from "../stores/staffDetailLog";
import { userStore } from "../stores/access";
/* ------- */

class StaffLogModal extends React.Component {
	isValidBrand(brand) {
		return brand !== null && typeof brand !== "undefined" && brand !== "" && !Number.isNaN(Number(brand)) && Number(brand) > 0;
	}

	loadStaffSessionDetail() {
		if (!this.isValidBrand(this.props.staffLog.brand)) {
			this.props.setStaffDetailLog({ ...this.props.staffDetailLog, loaded: true, data: [], pagination: { current: 1, total: 0 } });
			this.props.Interface.addNoty("Error", "Brand is required to load session detail log");
			return;
		}

		this.props.Interface.loadStaffSessionDetail(this.props.staffLog.token, this.props.staffLog.brand);
	}

	filter() {
		let data = cloneDeep(this.props.staffLog.data);
		if (!this.props.staffLog.currentSearch.length) {
			data.forEach((item) => {
				item.filtered = true;
			});
			this.props.setStaffLog({ ...this.props.staffLog, data });

			setTimeout(() => {
				let total = Math.ceil(
					this.props.staffLog.data.filter((item) => {
						return item.filtered;
					}).length / this.props.config.players.payments.perPage,
				);
				this.props.setStaffLog({ ...this.props.staffLog, pagination: { current: 1, total } });
			}, 0);
		} else {
			data.forEach((item) => {
				if (item.request.toString().indexOf(this.props.staffLog.currentSearch) !== -1 || item.method.toUpperCase().indexOf(this.props.staffLog.currentSearch.toUpperCase()) !== -1 || item.ip.toUpperCase().indexOf(this.props.staffLog.currentSearch.toUpperCase()) !== -1) item.filtered = true;
				else item.filtered = false;
			});

			this.props.setStaffLog({ ...this.props.staffLog, data });

			setTimeout(() => {
				let total = Math.ceil(
					this.props.staffLog.data.filter((item) => {
						return item.filtered;
					}).length / this.props.config.players.payments.perPage,
				);
				this.props.setStaffLog({ ...this.props.staffLog, pagination: { current: 1, total } });
			}, 0);
		}
	}

	render() {
		const brandContext = this.props.staffLog.brandName || (this.props.staffLog.brand ? "Brand #" + this.props.staffLog.brand : "");
		const description = brandContext ? "Below listed selected session log for " + brandContext : "Below listed selected session log";

		return (
			<>
				<Modal
					size="max"
					visible={this.props.staffLog.show}
					onDismiss={() => {
						this.props.setStaffLog({ ...this.props.staffLog, show: false, loaded: false, brand: null, brandName: "", data: [], pagination: { current: 1, total: 0 } });
					}}
					header={
						<Header
							children="Logs"
							counter={
								<>
									(
									{
										this.props.staffLog.data.filter((item) => {
											return item.filtered;
										}).length
									}
									)
								</>
							}
							description={description}
						/>
					}
					children={
						<>
							{this.props.staffLog.loaded && this.props.staffLog.error.text.length ? (
								<Box
									margin={{ bottom: "m" }}
									children={
										<Alert
											type="error"
											header="Error loading data:"
											children={
												<>
													<Box variant="p" children={this.props.staffLog.error.text} />
													<hr />
													<Box
														variant="p"
														children={
															<>
																request error code: {this.props.staffLog.error.code} | request timestamp: {this.props.staffLog.error.timestamp}
															</>
														}
													/>
												</>
											}
										/>
									}
								/>
							) : (
								<></>
							)}

							<Tabs
								onChange={(tab) => {

									if (tab.detail.activeTabId === "detail_log") {
										this.loadStaffSessionDetail();
									}
								}}
								tabs={[
									{
										id: "log_list",
										label: "Log list",
										content: <Table
											stickyHeader={true}
											wrapLines={true}
											loading={!this.props.staffLog.loaded}
											columnDefinitions={[
												{ id: "method", header: "Method", cell: (item) => item.method },
												{ id: "request", header: "Request", cell: (item) => item.request },
												{ id: "date", header: "Date", cell: (item) => new Date(item.date).toLocaleDateString() + " " + new Date(item.date).toLocaleTimeString() },
											]}
											items={this.props.staffLog.data.filter((item) => {
												return item.filtered;
											})
												.slice((this.props.staffLog.pagination.current - 1) * this.props.config.staff.log.perPage, this.props.staffLog.pagination.current * this.props.config.staff.log.perPage)}
											pagination={
												<Pagination
													disabled={!this.props.staffLog.loaded}
													currentPageIndex={this.props.staffLog.pagination.current}
													pagesCount={this.props.staffLog.pagination.total}
													onChange={(page) => {
														this.props.setStaffLog({ ...this.props.staffLog, pagination: { ...this.props.staffLog.pagination, current: page.detail.currentPageIndex } });
													}}
												/>
											}
											preferences={
												<Preferences
													cancelLabel="Cancel"
													confirmLabel="Confirm"
													pageSizePreference={{ title: "Logs per page", options: this.props.config.staff.log.preferences.perPage }}
													preferences={{ pageSize: this.props.config.staff.log.perPage }}
													title="Preferences"
													onConfirm={(preferences) => {
														localStorage.setItem("staff.log.perPage", preferences.detail.pageSize);
														this.props.setConfig({ ...this.props.config, staff: { ...this.props.config.staff, log: { ...this.props.config.staff.log, perPage: preferences.detail.pageSize } } });
														this.props.setStaffLog({
															...this.props.staffLog,
															pagination: {
																current: 1,
																total: Math.ceil(
																	this.props.staffLog.data.filter((item) => {
																		return item.filtered;
																	}).length / preferences.detail.pageSize,
																),
															},
														});
													}}
												/>
											}
											filter={
												<Input
													disableBrowserAutocorrect={true}
													placeholder="Method, IP or request part"
													type="search"
													inputMode="search"
													value={this.props.staffLog.currentSearch}
													onChange={(input) => {
														this.props.setStaffLog({ ...this.props.staffLog, currentSearch: input.detail.value });
														setTimeout(() => {
															this.filter();
														}, 100);
													}}
												/>
											}
											empty="No logs found with requested filter"
										/>
									},
									{
										id: "detail_log",
										label: "Detail log",
										content: <Table
											stickyHeader={true}
											wrapLines={true}
											loading={!this.props.staffDetailLog.loaded}
											columnDefinitions={[
												{ id: "method", header: "Method", cell: (item) => item.method },
												{ id: "project", header: "Project", sortingField: "project", cell: (item) => <img className={this.props.styles["withdrawalsBrand"]} src={document.body.classList[0] === "awsui-dark-mode" ?   this.props.user.brandsList[item.brand - 1].logoDark : this.props.user.brandsList[item.brand - 1].logo}></img> },
												{ id: "request", header: "Request", cell: (item) => item.request },
												{ id: "withdrawal_status", header: "Withdrawal status", cell: (item) => item.withdrawal_status ? item.withdrawal_status : "No" },
												{ id: "deposit_opened", header: "Deposit opened", cell: (item) => item.deposit_opened },
												{ id: "withdrawal_opened", header: "Withdrawal opened", cell: (item) => item.withdrawal_opened },
												{ id: "session_request", header: "Game session", cell: (item) => item.sessions_request ? item.sessions_request : "No" },
												{ id: "scroll", header: "Scroll to log", cell: (item) => item.scroll },
												{ id: "duration", header: "Duration", cell: (item) => item.duration_seconds },
												{ id: "start_time", header: "Start time", cell: (item) => new Date(item.start_time).toLocaleDateString() + " " + new Date(item.start_time).toLocaleTimeString() },
												{ id: "end_time", header: "End time", cell: (item) => new Date(item.end_time).toLocaleDateString() + " " + new Date(item.end_time).toLocaleTimeString() },
											]}
											items={this.props.staffDetailLog.data
												.slice((this.props.staffDetailLog.pagination.current - 1) * this.props.config.staff.log.perPage, this.props.staffDetailLog.pagination.current * this.props.config.staff.log.perPage)}
											pagination={
												<Pagination
													disabled={!this.props.staffDetailLog.loaded}
													currentPageIndex={this.props.staffDetailLog.pagination.current}
													pagesCount={this.props.staffDetailLog.pagination.total}
													onChange={(page) => {
														this.props.setStaffDetailLog({ ...this.props.staffDetailLog, pagination: { ...this.props.staffDetailLog.pagination, current: page.detail.currentPageIndex } });
													}}
												/>
											}
											preferences={
												<Preferences
													cancelLabel="Cancel"
													confirmLabel="Confirm"
													pageSizePreference={{ title: "Logs per page", options: this.props.config.staff.log.preferences.perPage }}
													preferences={{ pageSize: this.props.config.staff.log.perPage }}
													title="Preferences"
													onConfirm={(preferences) => {
														localStorage.setItem("staff.log.perPage", preferences.detail.pageSize);
														this.props.setConfig({ ...this.props.config, staff: { ...this.props.config.staff, log: { ...this.props.config.staff.log, perPage: preferences.detail.pageSize } } });
														this.props.setStaffDetailLog({
															...this.props.staffDetailLog,
															pagination: {
																current: 1,
																total: Math.ceil(
																	this.props.staffDetailLog.data.filter((item) => {
																		return item.filtered;
																	}).length / preferences.detail.pageSize,
																),
															},
														});
													}}
												/>
											}
											filter={
												<Grid
													gridDefinition={[{ colspan: 8 }, { colspan: 4 }]}
												>
													<Select
														filteringType="auto"
														placeholder="Group by"
														selectedOption={this.props.staffDetailLog.currentGroupBy}
														onChange={(option) => {
															this.props.setStaffDetailLog({
																...this.props.staffDetailLog,
																currentGroupBy: option.detail.selectedOption,
															});
														}}
														options={[{ value: 'player', label: 'player' }]}
													/>
													<Button>Submit</Button>
												</Grid>
											}
											empty="No logs found with requested filter"
										/>
									}
								]}

							/>
						</>
					}
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);
		const staffLog = useRecoilValue(staffLogModalStore);
		const setStaffLog = useSetRecoilState(staffLogModalStore);
		const staffDetailLog = useRecoilValue(staffDetailLogStore);
		const setStaffDetailLog = useSetRecoilState(staffDetailLogStore);
		const user = useRecoilValue(userStore);

		return <Component {...props} user={user} config={config} staffDetailLog={staffDetailLog} setStaffDetailLog={setStaffDetailLog} setConfig={setConfig} staffLog={staffLog} setStaffLog={setStaffLog} />;
	};
}

export default withRecoil(StaffLogModal);
